import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const fetchAgenticHireCandidateList = createAsyncThunk(
    "fetchAgenticHireCandidateList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/agentic/fetch-agentic-hire-candidate?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const AgenticHireCandidateslice = createSlice({
    name: "AgenticHireCandidateslice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAgenticHireCandidateList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchAgenticHireCandidateList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;


        });
        builder.addCase(fetchAgenticHireCandidateList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default AgenticHireCandidateslice.reducer;
